import * as React from "react";
import { Hotel } from "main/javascripts/types/hotel";
import { HotelRecommendedCard } from "./HotelRecommendedCard";
import { HotelIndexParam } from "main/javascripts/types/hotelIndexParam";

export interface IProps {
  hotels: Hotel.List[];
  param: HotelIndexParam;
}

export const HotelRecommendedList: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const { hotels, param } = props;
  return (
    <>
      {hotels.map((hotel: Hotel.List) => {
        return (
          <HotelRecommendedCard key={hotel.id} hotel={hotel} param={param} />
        );
      })}
    </>
  );
};
